// removed by extract-text-webpack-plugin
module.exports = {"form":"_2SWt0gqkYxw7kuSH-92ynR","inputContainer":"_239As9lagAz3qwJ8LtJW_J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPlaylistsCreateBar/MyPlaylistsCreateBar.scss
// module id = 1284
// module chunks = 1